var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VModal',{attrs:{"disable-backdrop-click":false},on:{"close":_vm.onClose},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('div',{staticClass:"mx-auto my-auto bg-white rounded p-2"},[_c('Loader')],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }